/* eslint-disable max-len */
import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';
import moment from 'moment';
import Grid from 'react-bootstrap/lib/Grid';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import Checkbox from 'react-bootstrap/lib/Checkbox';
import Button from 'react-bootstrap/lib/Button';
import HelpBlock from 'react-bootstrap/lib/HelpBlock';
import FormControl from 'react-bootstrap/lib/FormControl';
import InputElement from 'react-input-mask';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import Image from 'react-bootstrap/lib/Image';
import { Elements, injectStripe, StripeProvider } from 'react-stripe-elements';

import config from 'config';
import {
  buildSearchParams,
  getPriceInCurrency,
  getDefaultBookingDate,
  getDefaultDropDate,
  formatPrice,
  findCityById
} from 'utils';
import { loadScript } from 'utils/loader';

import { getTravelPayoutsSubId } from 'widgets/TravelPayouts';
import BikeCardGallery from 'widgets/BikeCard/BikeCardGallery';
import BikeCardRating from 'widgets/BikeCard/BikeCardRating';
import OrderStepsSection from 'widgets/OrderStepsSection';
import { redirect } from 'widgets/I18nLink';
import DatePicker from 'widgets/DatePicker';
import Preloader from 'widgets/Preloader';
import Dialog from 'widgets/Dialog/';
import Counter from 'widgets/Counter';
import Message from 'widgets/Message';
import OrderPrice from 'widgets/Order/OrderPrice';
import MapWithMarkers from 'widgets/MapWithMarkers';

import paymentImage from './payment.png';
import './DetailPage.css';
import Helmet from 'react-helmet';

const emailRegexp = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
const phoneMask = '+99999999999999999999';
const phoneRegexp = /^\+?\d+$/;

class ExtraItem extends Component {
  constructor(...args) {
    super(...args);

    this.toggleHandler = this.toggle.bind(this);
  }

  toggle() {
    this.props.onToggle(this.props.option.value);
  }

  render() {
    const {
      t,
      currency,
      option,
      optionsSelected
    } = this.props;

    let title = '';

    if (option.price) {
      const perDay = option.onetimePayment ? '' : `/${t('day')}`;
      title = <span>{option.title} {t('for')} {formatPrice(option.price)}&nbsp;{t(currency)}{perDay}</span>;
    } else {
      title = <span>{option.title} {t('for free')}</span>;
    }

    return (
      <Col lg={4} md={6} sm={6}>
        <Checkbox
          inline
          className="styled-checkbox"
          checked={optionsSelected.indexOf(option.value) > -1}
          onChange={this.toggleHandler}
        >
          <span className="checkbox-icon" />
          {title}
        </Checkbox>
      </Col>
    );
  }
}

class DetailPage extends Component {
  constructor(...args) {
    super(...args);

    this.toggleOptionHandler = this.onToggleOption.bind(this);

    this.toggleBeginDayPicker = this.toggleDayPicker.bind(this, 'begin');
    this.toggleEndDayPicker = this.toggleDayPicker.bind(this, 'end');

    this.beginDayChangeHandler = this.onDaySelect.bind(this, 'begin');
    this.endDayChangeHandler = this.onDaySelect.bind(this, 'end');

    this.onSelectBeginDateTime = this.onSelect.bind(this, 'beginDateTime');
    this.onSelectEndDateTime = this.onSelect.bind(this, 'endDateTime');

    this.submitPaymentHandler = this.onSubmitPayment.bind(this);

    this.openDialog = this.toggleDialog.bind(this, true);
    this.closeDialog = this.toggleDialog.bind(this, false);

    this.backToSearchHandler = this.onBackToSearch.bind(this);

    this.state = {
      open: false,
      openCheckout: false,

      bikeCount: 1,
      options: [],
      optionsSelected: [],

      beginDayPickerOpen: false,
      endDayPickerOpen: false,
      beginDateTime: getDefaultBookingDate(),
      endDateTime: getDefaultDropDate(),

      name: '',
      email: '',
      emailConfirm: '',
      phone: '',
      comment: '',
      promo: '',
      errors: {}
    };
  }

  componentWillMount() {
    const { bike, currency } = this.props;

    if (bike) {
      this.generateOptions(bike.company.extraItems, currency);
    }
  }

  componentDidMount() {
    this.applyParamsFromLocation(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const bikeChanged = nextProps.bike && nextProps.bike !== this.props.bike;
    const currencyChanged = nextProps.bike && nextProps.currency !== this.props.currency;

    // Update bike options
    if (bikeChanged || currencyChanged) {
      this.generateOptions(nextProps.bike.company.extraItems, nextProps.currency);
    }

    // Set form params
    if (nextProps.location.query !== this.props.location.query) {
      this.applyParamsFromLocation(nextProps);
    }

    // Update user info
    if (nextProps.user && (nextProps.user !== this.props.user)) {
      this.setState({
        name: nextProps.user.name || '',
        email: nextProps.user.email || '',
        emailConfirm: nextProps.user.email || '',
        phone: nextProps.user.phone || ''
      });
    }
  }

  applyParamsFromLocation(props) {
    const { beginDateTime, endDateTime } = buildSearchParams(props.location.query);

    this.setState({
      beginDateTime,
      endDateTime,
      bikeCount: Math.max(parseInt(props.location.query.count, 10) || 1, 1)
    });
  }

  generateOptions(extraItems, currency) {
    if (!extraItems) {
      this.setState({
        options: [],
        optionsSelected: []
      });

      return;
    }

    const { t, location } = this.props;

    const options = extraItems.map((option) => ({
      title: t(option.extraItemType.nameEn, { ns: 'extraItemTypes' }),
      price: getPriceInCurrency(option.price, currency),
      value: option.id,
      onetimePayment: option.onetimePayment
    }));

    this.setState({ options });

    let optionsSelected = options.map((option) => option.value);

    const extras = location.query.extras;
    if (extras) {
      const extraValues = extras.split(',').map((v) => parseInt(v, 10));
      optionsSelected = optionsSelected.filter((v) => extraValues.indexOf(v) !== -1);
    } else {
      optionsSelected = [];
    }

    this.setState({ optionsSelected });
  }

  onToggleOption(value) {
    const optionsSelected = this.state.optionsSelected.slice(0);
    const index = optionsSelected.indexOf(value);

    if (index > -1) {
      optionsSelected.splice(index, 1);
    } else {
      optionsSelected.push(value);
    }

    redirect({
      pathname: this.props.location.pathname,
      query: {
        ...this.props.location.query,
        extras: optionsSelected.join(',')
      }
    });
  }

  toggleDayPicker(kind) {
    this.setState((prevState) => ({
      beginDayPickerOpen: (kind === 'begin') ? !prevState.beginDayPickerOpen : false,
      endDayPickerOpen: (kind === 'end') ? !prevState.endDayPickerOpen : false
    }));
  }

  handleCounterChange = (value) => {
    const { bike, location } = this.props;
    const bikeCount = Math.min(Math.max(1, value), bike.freeCount);

    redirect({
      pathname: location.pathname,
      query: {
        ...location.query,
        count: bikeCount
      }
    });
  };

  handleFieldChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  validate = () => {
    const { name, email, emailConfirm, phone } = this.state;
    const errors = {};

    if (name.length < 2) {
      errors.name = 'error';
    }

    if (!emailRegexp.test(email)) {
      errors.email = 'error';
    }

    if (!emailConfirm || emailConfirm !== email) {
      errors.emailConfirm = 'error';
    }

    if (!phoneRegexp.test(phone.replace(/ /g, ''))) {
      errors.phone = 'error';
    }

    this.setState({ errors });

    return !Object.keys(errors).length;
  };

  updateDateTime(kind, newMoment) {
    const minBegin = moment()
      .set('minutes', 0)
      .set('seconds', 0)
      .set('milliseconds', 0)
      .add(1, 'hour')
      .add(config.minimalBookingOffset, 'hour');

    if (kind === 'begin' && newMoment.isBefore(minBegin)) {
      newMoment = minBegin;
    }

    const upd = { [kind]: newMoment.toISOString() };

    if (kind === 'begin') {
      const endMoment = moment(new Date(this.state.endDateTime));

      if (newMoment.isAfter(endMoment.subtract(1, 'hour'))) {
        upd.end = moment(newMoment).add(1, 'day').toISOString();
      }
    } else if (kind === 'end') {
      const beginMoment = moment(new Date(this.state.beginDateTime));

      if (newMoment.isBefore(beginMoment.add(1, 'hour'))) {
        upd.end = moment(beginMoment).toISOString();
      }
    }

    return upd;
  }

  onDaySelect(kind, date, modifiers) {
    if (modifiers.disabled) {
      return;
    }

    const { location, countries } = this.props;

    const { pickUpCity, dropOfCity } = location.query;
    const cityId = parseInt(kind === 'begin' ? pickUpCity : dropOfCity, 10);
    const city = findCityById(countries, cityId);

    const paramName = `${kind}DateTime`;
    const prevMoment = moment(new Date(this.state[paramName]));
    if (city && city.timezoneName) {
      prevMoment.tz(city.timezoneName); // keepTime = false
    }

    const newMoment = moment(new Date(date));
    if (city && city.timezoneName) {
      newMoment.tz(city.timezoneName, true); // keepTime = true
    }

    newMoment
      .set('hour', prevMoment.get('hour'))
      .set('minute', prevMoment.get('minute'));

    const updated = this.updateDateTime(kind, newMoment);

    this.toggleDayPicker();

    redirect({
      pathname: location.pathname,
      query: { ...location.query, ...updated }
    });
  }

  onSelect = (key, value) => {
    this.setState({ [key]: value });

    if (key === 'beginDateTime' || key === 'endDateTime') {
      const kind = key === 'beginDateTime' ? 'begin' : 'end';

      const updated = this.updateDateTime(kind, moment(new Date(value)));

      redirect({
        pathname: this.props.location.pathname,
        query: { ...this.props.location.query, ...updated }
      });
    }
  };

  onBackToSearch() {
    const {
      bikeTypes,
      pickUpCity,
      dropOfCity,
      begin,
      end,
      age,
      ordering
    } = this.props.location.query;

    redirect({
      pathname: '/search/',
      query: {
        bikeTypes,
        pickUpCity,
        dropOfCity,
        begin,
        end,
        age,
        ordering
      }
    });
  }

  onSubmitPayment() {
    const isValid = this.validate();
    if (!isValid) {
      return;
    }

    const {
      bike,
      currency,
      location
    } = this.props;

    if (!bike || (!bike.price && !bike.salesPrice)) {
      return;
    }

    const amount = getPriceInCurrency(bike.deposit, currency);
    if (!amount) {
      return;
    }

    const {
      beginDateTime,
      endDateTime,
      bikeCount: count,
      name,
      email,
      phone,
      comment,
      optionsSelected
    } = this.state;

    const order = {
      bike: bike.id,
      beginTime: beginDateTime,
      endTime: endDateTime,
      dropOffLocation: location.query.dropOfCity,
      userName: name,
      userEmail: email,
      userPhone: phone.replace(' ', ''),
      comment,
      count,
      partner: location.query.code,
      travelPayoutsId: getTravelPayoutsSubId(),

      orderExtraItems: optionsSelected.map((id) => ({
        extraItem: id,
        count: 1
      }))
    };

    this.props.createOrder(order).then((result) => {
      const { response, error } = result;

      if (!response || error) {
        this.setState({ errors: error });
        return;
      }

      const {
        transaction: transactionId,
        order
      } = response;

      const {
        currency,
        location,
        createTransaction,
        stripe
      } = this.props;

      if (order) {
        this.setState({ order });

        if (bike.company.bookingMode === 'Free') {
          redirect({
            pathname: `/transaction/${transactionId}/`,
            query: {
              ...location.query,
              bikeId: order.bike
            }
          });
        }
      }

      return createTransaction({ order, currency }).then((result) => {
        const { sessionId } = result.response;

        stripe.redirectToCheckout({ sessionId }).then((result) => {
          console.log(result.error.message);
        });
      });
    });
  }

  toggleDialog = (open) => {
    this.setState({ open });
  };

  getStatus = (field) => this.state.errors[field];

  getDisabledDays() {
    const minBegin = moment()
      .set('minutes', 0)
      .set('seconds', 0)
      .set('milliseconds', 0)
      .add(1, 'hour')
      .add(config.minimalBookingOffset, 'hour');

    return {
      before: minBegin.toDate()
    };
  }

  render() {
    const {
      t,
      bike,
      bikeTypes,
      countries,
      isFetching,
      isModerator,
      location,
      stripe
    } = this.props;

    const isAvailable = bike && (bike.price || bike.salesPrice);

    const bikeType = bike && bikeTypes && bikeTypes.find(({ id }) => id === bike.bikeType);
    const bikeTypeName = bikeType ? t(bikeType.name, { ns: 'bikeTypes' }) : '';

    const pickUpCityId = parseInt(location.query.pickUpCity, 10);
    const pickUpCity = findCityById(countries, pickUpCityId);

    const dropOfCityId = parseInt(location.query.dropOfCity, 10);
    const dropOfCity = findCityById(countries, dropOfCityId);

    return (
      <div className="order-page">
        <Helmet
          meta={[{
            name: 'robots',
            content: 'noindex, follow'
          }]}
        />

        <OrderStepsSection
          activeStep={2}
          orderParamsString=""
          title={t('Search rentals')}
        />

        <Dialog
          open={this.state.open}
          onClose={this.closeDialog}
        >
          {!!bike && (
            <MapWithMarkers
              zoom={14}
              markers={[{
                position: {
                  lat: bike.company.lat,
                  lng: bike.company.lng
                }
              }]}
            />
          )}
        </Dialog>

        <Grid>
          <div className="order-page-block order-card order-bike">
            <Row className="bike-info">
              {(!!isFetching && !bike) && (
                <Col lg={12} className="bike-preloader">
                  <Preloader cubeStyle={{ backgroundColor: '#5080c5' }}/>
                </Col>
              )}

              {!!bike && (
                <Col lg={12}>
                  <Row>
                    <Col lg={4} md={4}>
                      <BikeCardGallery
                        photos={bike.photos}
                      />

                      <BikeCardRating
                        bike={bike}
                        showProvider={isModerator}
                      />
                    </Col>

                    <Col lg={8} md={8}>
                      <Row className="bike-card-info">
                        <Col lg={12}>
                          <h3>{bikeTypeName} {bike.name}</h3>

                          <p>
                            <span
                              className="bike-card-show-on-map"
                              onClick={this.openDialog}
                            >
                              {t('Show on the map')}
                            </span>
                          </p>
                        </Col>
                        <Col lg={6} md={6} sm={12}>
                          {!!bike.description && (
                            <p>
                              <b>{t('Description')}:</b>
                              {bike.description.split('\n').map((item, key) => (
                                <span key={key}>{item}<br/></span>
                              ))}
                            </p>
                          )}

                          {!!bike.drivingLicense && (
                            <p>
                              <b>{t('Driver\'s license')}:</b>
                              <span className="bike-card-license">
                                {t(bike.drivingLicense)}
                              </span>
                            </p>
                          )}

                          {!!bike.minAge && (
                            <p>
                              <b>{t('Minimum age')}:</b>
                              {bike.minAge}
                            </p>
                          )}

                          {!!bike.cdwAmount && (
                            <p>
                              <b>{t('CDW (maximum liability in case of damage)')}:</b>
                              {bike.cdwAmount}
                            </p>
                          )}

                          {!!bike.securityDeposit && (
                            <p>
                              <b>{t('Security deposit for the bike')}:</b>
                              {bike.securityDeposit}
                            </p>
                          )}
                        </Col>

                        <Col lg={6} md={6} sm={12}>
                          {!!bike.company.description && (
                            <p>
                              <b>{t('Terms and Conditions of the rental company')}:</b>
                              {bike.company.description}
                            </p>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              )}
            </Row>

            <hr />

            {!!bike && (
              <Row className="bike-options">
                <div className="bike-counter">
                  <Counter
                    title={t('Number of bikes')}
                    value={this.state.bikeCount}
                    minValue={1}
                    maxValue={bike.freeCount}
                    onChange={this.handleCounterChange}
                  />
                </div>

                <div className="addition-options">
                  <FormGroup className="checkboxes-form-group">
                    <ControlLabel>
                      {t('Additional services')}:
                    </ControlLabel>

                    <Row>
                      {this.state.options.map((option) => (
                        <ExtraItem
                          key={option.value}
                          t={t}
                          option={option}
                          optionsSelected={this.state.optionsSelected}
                          onToggle={this.toggleOptionHandler}
                          currency={this.props.currency}
                        />
                      ))}
                    </Row>
                  </FormGroup>
                </div>
              </Row>
            )}
          </div>

          {!!bike && (
            <div className="order-page-block order-card order-form">
              <Row>
                <Col lg={6} md={7} className="order-info">
                  <h2>{t('Information about your reservation')}</h2>

                  <div className="order-group">
                    <ControlLabel>
                      {t('Pick-up location')}:
                      {' '}
                      <span
                        className="bike-card-show-on-map"
                        onClick={this.openDialog}
                      >
                        {pickUpCity && t(pickUpCity.name, { ns: 'cities' })}
                      </span>
                    </ControlLabel>

                    <Message>
                      {t('You will find an exact address in the booking confirmation. If you ordered a delivery, please specify an address in the comment to the reservation.')}
                    </Message>
                  </div>

                  {!!bike.company.workingHours && (
                    <div className="order-group">
                      <ControlLabel>
                        {t('Working hours of the rental company')}:
                        {' '}
                        <b>{bike.company.workingHours}</b>
                      </ControlLabel>

                      <Message>
                        {t('Please check if your pick-up and drop-off time is in the working hours of the rental company.')}
                      </Message>
                    </div>
                  )}

                  <DatePicker
                    dayPickerOpened={this.state.beginDayPickerOpen}
                    toggleDayPicker={this.toggleBeginDayPicker}
                    label={`${t('Pick-up Date')}:`}
                    timeChangeHandler={this.onSelectBeginDateTime}
                    dayChangeHandler={this.beginDayChangeHandler}
                    dateTimeValue={this.state.beginDateTime}
                    timezone={pickUpCity && pickUpCity.timezoneName}
                    disabledDays={this.getDisabledDays()}
                  />

                  <DatePicker
                    dayPickerOpened={this.state.endDayPickerOpen}
                    toggleDayPicker={this.toggleEndDayPicker}
                    label={`${t('Drop-off Date')}:`}
                    timeChangeHandler={this.onSelectEndDateTime}
                    dayChangeHandler={this.endDayChangeHandler}
                    dateTimeValue={this.state.endDateTime}
                    timezone={dropOfCity && dropOfCity.timezoneName}
                    disabledDays={{ before: moment(this.state.beginDateTime).add(1, 'hour').toDate() }}
                  />

                  <FormGroup
                    controlId="name"
                    validationState={this.getStatus('name')}
                  >
                    <ControlLabel>
                      {t('Name and Surname of the driver')}:
                    </ControlLabel>

                    <FormControl
                      name="name"
                      value={this.state.name}
                      onChange={this.handleFieldChange}
                      onBlur={this.validate}
                    />
                  </FormGroup>

                  <FormGroup
                    controlId="email"
                    validationState={this.getStatus('email')}
                  >
                    <ControlLabel>
                      {t('E-mail')}:
                    </ControlLabel>

                    <FormControl
                      name="email"
                      value={this.state.email}
                      onChange={this.handleFieldChange}
                      onBlur={this.validate}
                    />

                    <HelpBlock>
                      {t('You will receive your Voucher on this email.')}
                    </HelpBlock>
                  </FormGroup>

                  <FormGroup
                    controlId="emailConfirm"
                    validationState={this.getStatus('emailConfirm')}
                  >
                    <ControlLabel>
                      {t('E-mail one more time')}:
                    </ControlLabel>

                    <FormControl
                      name="emailConfirm"
                      value={this.state.emailConfirm}
                      onChange={this.handleFieldChange}
                      onBlur={this.validate}
                    />
                  </FormGroup>

                  <FormGroup
                    controlId="phone"
                    validationState={this.getStatus('phone')}
                  >
                    <ControlLabel>
                      {t('Phone number')}:
                    </ControlLabel>

                    <InputElement
                      className="form-control"
                      name="phone"
                      value={this.state.phone}
                      onChange={this.handleFieldChange}
                      onBlur={this.validate}
                      mask={phoneMask} maskChar=""
                    />

                    <HelpBlock>
                      {t('Mobile phone with a country code. Make sure it will work if you ordered a delivery.')}
                    </HelpBlock>
                  </FormGroup>

                  <FormGroup
                    controlId="comment"
                    validationState={this.getStatus('comment')}
                  >
                    <ControlLabel>
                      {t('Comments to the reservation')}:
                    </ControlLabel>

                    <FormControl
                      componentClass="textarea"
                      name="comment"
                      value={this.state.comment}
                      onChange={this.handleFieldChange}
                      onBlur={this.validate}
                    />

                    <HelpBlock>
                      {t('(flight number or your address in case of delivery, your wishes or other important info)')}
                    </HelpBlock>
                  </FormGroup>
                </Col>

                <Col
                  lg={4} lgPush={2} md={5}
                  className="order-reservation"
                >
                  <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                      <div className="order-group">
                        {isAvailable && (
                          <OrderPrice
                            bike={bike}
                            currency={this.props.currency}
                            bikeIsReloading={isFetching}
                          />
                        )}

                        {!isAvailable && (
                          <div className="order-error">
                            {!isFetching && (
                              <Fragment>
                                <div className="order-error-title">
                                  {t('We’re sorry, but it looks like there are no bikes available at the moment.')}
                                </div>

                                <div className="order-error-text">
                                  {t('Please try changing your booking dates, and we’ll gladly check for availability!')}
                                </div>
                              </Fragment>
                            )}

                            {isFetching && (
                              <div className="order-error-preloader">
                                <Preloader cubeStyle={{ backgroundColor: '#de6666' }}/>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </Col>

                    <Col lg={12} md={12} sm={6} xs={12}>
                      {(bike.company.bookingMode !== 'Free') && (
                        <div className="order-group order-condition">
                          <ControlLabel>
                            {t('Cancellation terms')}:
                          </ControlLabel>

                          <p>{t('Cancellation is free of charge at any time if you notify us before your rental started. Amount which you pay online now is not refundable.')}</p>
                        </div>
                      )}

                      <div className="order-group order-condition">
                        <ControlLabel>
                          {t('Modification terms')}:
                        </ControlLabel>

                        <p>{t('Modification of your reservation is free of charge. You will need just to contact BikesBooking.com Customer Support Team by email.')}</p>
                      </div>
                    </Col>

                    <Col lg={12} md={12} sm={6} xs={12}>
                      <div className="order-group">
                        {(bike.company.bookingMode === 'Instant') && (
                          <Message flavor="info-lightning">
                            {t('Instant booking confirmation only on our website!')}
                          </Message>
                        )}

                        {(bike.company.bookingMode === 'Confirm') && (
                          <Message flavor="info-yellow">
                            {t('Make a reservation and receive a voucher. For this bike we don\'t have an instant booking, if the rental company can\'t confirm this bike - your payment will be automatically refunded!')}
                          </Message>
                        )}

                        {(bike.company.bookingMode === 'Free') && (
                          <Message flavor="info-dark">
                            {t('No payment is required now. You can pay the full price on arrival. Plans have changed? Just cancel the reservation without losing money.')}
                          </Message>
                        )}
                      </div>

                      <div className="order-group">
                        <Button
                          bsStyle="danger"
                          disabled={!stripe || !isAvailable}
                          type="button"
                          className="order-button"
                          onClick={this.submitPaymentHandler}
                        >
                          {t('Pay & Reserve My bike')}
                        </Button>
                      </div>

                      {this.getStatus('count') && (
                        <div className="order-group">
                          <Message flavor="error">
                            {this.getStatus('count').map((item) => (
                              <div key={item}>
                                {item}
                              </div>
                            ))}
                          </Message>
                        </div>
                      )}

                      {(bike.company.bookingMode !== 'Free') && (
                        <div className="order-group">
                          <Message flavor="security">
                            {t('Pay in a new secured window and receive your Voucher. We do not store your card details and never share this information with third parties!')}
                          </Message>
                        </div>
                      )}

                      <div className="order-group">
                        <Image
                          alt="russia and ireland"
                          className="payment-info"
                          src={paymentImage}
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          )}

          {!!location.query && (
            <div
              className="order-page-block"
              onClick={this.backToSearchHandler}
            >
              <a className="to-search-results">
                {t('Back to search results')}
              </a>
            </div>
          )}
        </Grid>
      </div>
    );
  }
}

const StripeDetailPage = injectStripe(DetailPage);

class DetailWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stripe: null
    };
  }

  onLoad() {
    this.setState({
      stripe: window.Stripe(config.stripeApiKey)
    });
  }

  componentDidMount() {
    loadScript('stripe-js', 'https://js.stripe.com/v3/').then(() => {
      if (window.Stripe) {
        this.onLoad();
      }
    });
  }

  render() {
    const { stripe } = this.state;

    return (
      <StripeProvider stripe={stripe}>
        <Elements>
          <StripeDetailPage {...this.props} />
        </Elements>
      </StripeProvider>
    );
  }
}

export default  translate(['detail', 'extraItemTypes', 'translation'])(DetailWrapper);



// WEBPACK FOOTER //
// ./src/components/DetailPage/DetailPage.js